import React from 'react';
import PropTypes from 'prop-types';
import screenResolution from '../../utils/screen-resolution';
import NewsWidget from '../../lib/ui/widgets/News/NewsWidget';

const HomePageNews = (props) => {
  const resolution = screenResolution();
  const { fields } = props;

  return (
    <NewsWidget resolution={resolution} fields={fields} />
  );
};

HomePageNews.propTypes = {
  fields: PropTypes.object,
};

export default HomePageNews;
